import { configureStore } from "@reduxjs/toolkit";

import { errorMiddleware, eventInsightsMiddleware } from "./store/middleware";
import reducer from "./store/reducers/reducers";

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }).concat(errorMiddleware, eventInsightsMiddleware),
});

export default store;